module.exports = __webpack_public_path__ + "static/media/theme-landing-2.90af4c07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/theme-landing-2.jpg
// module id = 360
// module chunks = 0